exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._23wDhqTzTGlfWmDaMuO3Pr{display:inline-block}html[dir=ltr] ._23wDhqTzTGlfWmDaMuO3Pr{padding-right:10px}html[dir=rtl] ._23wDhqTzTGlfWmDaMuO3Pr{padding-left:10px}", ""]);

// exports
exports.locals = {
	"spinner": "_23wDhqTzTGlfWmDaMuO3Pr"
};